import { render, staticRenderFns } from "./ProjectsDone.vue?vue&type=template&id=40e49efe&scoped=true"
import script from "./ProjectsDone.vue?vue&type=script&lang=js"
export * from "./ProjectsDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e49efe",
  null
  
)

export default component.exports